// Convert Microsoft Graph event to Meeting object
export const convertEventToMeeting = (event, organizerPhotoUrl, organizerHasJoined) => {
  const meeting = {
    id: event.id,
    title: event.subject || 'Sin título',
    subject: event.subject,
    scheduledStart: event.start.dateTime,
    scheduledEnd: event.end.dateTime,
    timeZone: event.start.timeZone || 'UTC',
    organizer: {
      name: event.organizer.emailAddress.name || event.organizer.emailAddress.address,
      email: event.organizer.emailAddress.address,
      photoUrl: organizerPhotoUrl,
      hasJoined: organizerHasJoined,
    },
    status: getMeetingStatus(event.start.dateTime, event.end.dateTime, event.start.timeZone),
    participantCount: event.attendees ? event.attendees.length : 0,
    expectedParticipants: event.attendees ? event.attendees.length : 0,
    joinUrl: event.onlineMeeting?.joinUrl || event.webLink,
    isOrganizer: event.isOrganizer || false,
  };

  return meeting;
};

// Determine meeting status based on current time
export const getMeetingStatus = (startDateTime, endDateTime, timeZone) => {
  const now = new Date();
  
  // Parse start and end times
  let startTime, endTime;
  
  // Handle timezone properly
  const hasTzStart = startDateTime.endsWith('Z') || startDateTime.match(/[-+]\d{2}:?\d{2}$/);
  const hasTzEnd = endDateTime.endsWith('Z') || endDateTime.match(/[-+]\d{2}:?\d{2}$/);
  
  if (!hasTzStart && timeZone === 'UTC') {
    const cleanStartDate = startDateTime.replace(/\.\d+$/, '') + 'Z';
    startTime = new Date(cleanStartDate);
  } else {
    startTime = new Date(startDateTime);
  }
  
  if (!hasTzEnd && timeZone === 'UTC') {
    const cleanEndDate = endDateTime.replace(/\.\d+$/, '') + 'Z';
    endTime = new Date(cleanEndDate);
  } else {
    endTime = new Date(endDateTime);
  }

  if (now < startTime) {
    return 'not_started';
  } else if (now >= startTime && now < endTime) {
    return 'in_progress';
  } else {
    return 'ended';
  }
};

// Format date for display
export const formatMeetingDate = (dateString, timeZone) => {
  let date;
  
  const hasTz = dateString.endsWith('Z') || dateString.match(/[-+]\d{2}:?\d{2}$/);
  
  if (!hasTz && timeZone === 'UTC') {
    const cleanDate = dateString.replace(/\.\d+$/, '') + 'Z';
    date = new Date(cleanDate);
  } else {
    date = new Date(dateString);
  }
  
  return {
    date: date.toLocaleDateString('es-ES'),
    time: date.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit'
    }),
    full: date.toLocaleString('es-ES'),
  };
};

// Get meeting duration in minutes
export const getMeetingDuration = (startDateTime, endDateTime, timeZone) => {
  let startTime, endTime;
  
  const hasTzStart = startDateTime.endsWith('Z') || startDateTime.match(/[-+]\d{2}:?\d{2}$/);
  const hasTzEnd = endDateTime.endsWith('Z') || endDateTime.match(/[-+]\d{2}:?\d{2}$/);
  
  if (!hasTzStart && timeZone === 'UTC') {
    const cleanStartDate = startDateTime.replace(/\.\d+$/, '') + 'Z';
    startTime = new Date(cleanStartDate);
  } else {
    startTime = new Date(startDateTime);
  }
  
  if (!hasTzEnd && timeZone === 'UTC') {
    const cleanEndDate = endDateTime.replace(/\.\d+$/, '') + 'Z';
    endTime = new Date(cleanEndDate);
  } else {
    endTime = new Date(endDateTime);
  }

  const durationMs = endTime.getTime() - startTime.getTime();
  return Math.round(durationMs / (1000 * 60)); // Convert to minutes
};

// Check if meeting is today
export const isMeetingToday = (startDateTime, timeZone) => {
  let meetingDate;
  
  const hasTz = startDateTime.endsWith('Z') || startDateTime.match(/[-+]\d{2}:?\d{2}$/);
  
  if (!hasTz && timeZone === 'UTC') {
    const cleanDate = startDateTime.replace(/\.\d+$/, '') + 'Z';
    meetingDate = new Date(cleanDate);
  } else {
    meetingDate = new Date(startDateTime);
  }
  
  const today = new Date();
  
  return (
    meetingDate.getDate() === today.getDate() &&
    meetingDate.getMonth() === today.getMonth() &&
    meetingDate.getFullYear() === today.getFullYear()
  );
};